// Globo Product Options の表示を日本語に寄せ、カートの項目名をパーツ名に直す。
//
// 1. 文言 — アプリの翻訳設定に入力欄が無い4項目だけをここで上書きする。
//    残りはアプリ側（設定 → 翻訳）が正典なので触らない。
// 2. 項目名 — Globo は line item property 名に要素 ID（radio-1 など）を使う。
//    管理画面の「label on cart」が 642 要素で未設定のため、カートと注文に radio-1 が並ぶ。
//    Globo は値の更新時に name を毎回書き戻すので、監視して書き換え直す。
//    Globo 自身は data-field-name で要素を引くため、name の書き換えは Globo の動作に影響しない。
(() => {
  const TRANSLATIONS = {
    widget: { uploaded_msg: 'アップロード済み:', uploaded_link: 'リンク' },
    addtocart: {
      buynow_not_allowed:
        'この商品はこの決済方法では購入できません。カートに追加してから、カートで購入手続きへお進みください。',
    },
    cart: { cancel: 'キャンセル' },
  };

  // Globo は translations を gpomain.js の実行中に組み立てるので、
  // 読み込み順によってはこの時点でまだ無い。該当4項目はいずれも操作して初めて出る文言のため、
  // 短く待てば表示前に間に合う。
  const translate = () => {
    const target = window.GPOConfigs && window.GPOConfigs.translations;
    if (!target) return false;
    Object.entries(TRANSLATIONS).forEach(([group, strings]) => {
      if (target[group]) Object.assign(target[group], strings);
    });
    return true;
  };

  if (!translate()) {
    const timer = setInterval(() => {
      if (translate()) clearInterval(timer);
    }, 100);
    setTimeout(() => clearInterval(timer), 10000);
  }

  const FORM = 'form[action*="/cart/add"]';
  const FIELDS = '[data-field-name][name^="properties["]';

  const labelsOf = (form) => {
    const sets = window.GPOConfigs && window.GPOConfigs.options;
    if (!sets) return null;
    const labels = {};
    form.querySelectorAll('input[name="properties[_has_gpo]"]').forEach((input) => {
      const set = sets[input.value];
      if (!set) return;
      const walk = (element) => {
        (element.elements || []).forEach(walk);
        if (element.type === 'group' || !element.id) return;
        const onCart = element.label_on_cart;
        labels[element.id] = onCart && onCart !== element.id ? onCart : element.label;
      };
      (set.elements || []).forEach(walk);
    });
    return labels;
  };

  const rename = (form) => {
    const labels = labelsOf(form);
    if (!labels) return;
    const taken = new Set();
    form.querySelectorAll(FIELDS).forEach((field) => {
      const label = labels[field.getAttribute('data-field-name')];
      if (!label) return;
      let name = label;
      for (let suffix = 2; taken.has(name); suffix += 1) name = `${label} ${suffix}`;
      taken.add(name);
      if (field.name !== `properties[${name}]`) field.name = `properties[${name}]`;
    });
  };

  const observe = (form) => {
    new MutationObserver(() => rename(form)).observe(form, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['name', 'data-field-name'],
    });
    rename(form);
  };

  document.querySelectorAll(FORM).forEach(observe);
})();
